/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowCollapseTrianglesVClosedIcon24Solid = forwardRef('ArrowCollapseTrianglesVClosedIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "m4.487 4.987 4.861 4.861a3.75 3.75 0 0 0 5.303 0l4.861-4.86C20.615 3.884 19.834 2 18.275 2H5.725c-1.56 0-2.34 1.885-1.238 2.987Z" }),
        React.createElement("path", { d: "m4.487 19.013 4.861-4.861a3.75 3.75 0 0 1 5.303 0l4.861 4.86c1.103 1.103.322 2.988-1.237 2.988H5.725c-1.56 0-2.34-1.885-1.238-2.987Z" })));
});
